import script from "./DictionaryTypesModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DictionaryTypesModal.vue?vue&type=script&lang=ts&setup=true"

import "./DictionaryTypesModal.vue?vue&type=style&index=0&id=da8433ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da8433ac"]])

export default __exports__